import {AREA_UNIT_TYPES} from "./fields/constants"

export const getPolylineDistance = function (layer, precision = 2) {
  let distance = 0
  const latLngs = layer.getLatLngs()
  for (let i=0; i < (latLngs.length) - 1; i++) {
    distance += parseFloat(latLngs[i].distanceTo(latLngs[i+1]))
  }
  distance = distance.toFixed(precision)
  return distance
}

export const getFloatAreaInUnit = (value, unit) => {
  switch (unit) {
    case AREA_UNIT_TYPES.HECTARE:
      return value
    case AREA_UNIT_TYPES.SQUARE_CENTIMETERS:
      return value * 1e+8
    case AREA_UNIT_TYPES.SQUARE_METERS:
      return value * 10000
    case AREA_UNIT_TYPES.SQUARE_KILOMETERS:
      return value / 100
    default:
      return value
  }
}
